import "./footer.scss";
import { allImages } from "../../services/images";
import { useAppSelector } from "../../Redux/hook";
import { links } from "../Reusable/resuable";
import { SocialMediaLinks } from "../../services/data";
export default function Footer() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return <footer>
        <div className="footer">
            <div className="one">
                <img src={allImages.logo} alt="logo" />
                <hr color="white" />
                <div className="tdimage">PBL Transport Corporation</div>
                <div>Private Limited</div>
            </div>
            <div className="two">
                <div>
                    <h5>Main Menu</h5>
                    <div className="section">
                        {
                            links.map((item, i) => i < 4 ? <a className="tag" href={item.path} key={i}>{item.name}</a> : <span />)
                        }
                    </div>
                </div>
                <div>
                    <h5>Insights</h5>
                    <div className="section">
                        {
                            links.map((item, i) => i >= 4 ? <a className="tag" href={item.path} key={i}>{item.name}</a> : <span />)
                        }
                    </div>
                </div>
                <div className="desktop">
                    <h5>Contact Us</h5>
                    <div className="section">
                        <div className="tag" >+91 0891 6661277</div>
                        <div className="tag" >+91 9951001277</div>
                        <div className="tag" >sales@pbltransport.co.in</div></div>
                </div>
                {/* <div className="desktop">
                    <h5>Policies</h5>
                    <div className="section">
                        <div onClick={() => window.open(allImages.csrpolicy)} className="tag" >CSR Policy</div>
                        <div onClick={() => window.open(allImages.health)} className="tag" >Quality Occupational Health and Safety Policy</div>
                    </div>
                </div> */}
            </div>
            <div className="three">
                {/* <div className="mobile mb-3">
                    <h5>Policies</h5>
                    <div className="section">
                        <div onClick={() => window.open(allImages.csrpolicy)} className="tag" >CSR Policy</div>
                        <div onClick={() => window.open(allImages.health)} className="tag" >Quality Occupational Health and Safety Policy</div>
                    </div>
                </div> */}
                <div className="mobile mb-2">
                    <h5>Contact Us</h5>
                    <div className="tag" >0891 6661277</div>
                    <div className="tag" >sales@pbltransport.co.in</div>
                </div>
                <div className="mobile"><strong>CIN NO : U63011AP1995PTC022556</strong></div>
                <div><strong>GSTN : 37AABCP3169R2ZP</strong></div>
                <img src={allImages.iso} alt="logo" width={249} height={116} onClick={() => window.open(allImages.isocert)} />
            </div>
        </div>
        <div className="bgImage">
        </div>
        <div className="iconslist">
            <div className="icons">
                {
                    SocialMediaLinks.map((item, i) => <a rel="noreferrer" target="_blank" key={item.name} href={item.link} style={{ background: lightMode ? "#ecf0f3" : "transparent", color: item.color }} className="fb"><i>{item.icon}</i></a>)
                }
            </div>
        </div>
        <div className="rights">© 2025 All Rights Reserved</div>
    </footer>
}